import React from "react";
import useIsOverflowing from "./useIsOverflowing"; // Import the hook
import CustomTooltip from "../Tooltip"; // Tooltip component

const OverflowText = ({ text, className = "sub-domain-heading" }) => {
    const { ref, isOverflowing } = useIsOverflowing();

    return isOverflowing ? (
        <CustomTooltip content={text} position="top">
            <p className={className} ref={ref}>{text}</p>
        </CustomTooltip>
    ) : (
        <p className={className} ref={ref}>{text}</p>
    );
};

export default OverflowText;
